<template>
  <NavbarFive class="home_one" />
  <ResponsiveNavbar class="home_one" />
  <PageBanner pageTitle="Contact Us" mainTitle="Contact Us" />
  <ContactInfo />
  <ContactForm />
  <DownloadTheApp />
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavbarFive from "../components/Layouts/NavbarFive.vue";
import ResponsiveNavbar from "../components/Layouts/ResponsiveNavbar.vue";
import PageBanner from "../components/Common/PageBanner.vue";
import ContactInfo from "../components/ContactUs/ContactInfo.vue";
import ContactForm from "../components/ContactUs/ContactForm.vue";
import DownloadTheApp from "../components/Common/DownloadTheApp.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "ContactUsPage",
  components: {
    NavbarFive,
    ResponsiveNavbar,
    PageBanner,
    ContactInfo,
    ContactForm,
    DownloadTheApp,
    MainFooter,
  },
});
</script>